import React from 'react';
import './customer-location-modal.scss';
import { Box, Skeleton, SwipeableDrawer } from '@mui/material';
import { TouchableOpacity } from '../../../../common';
import { ReactComponent as SearchIcon } from '@zonofi/svg-icons/search-icon.svg';
import {
  dispatch,
  FormattedLocation,
  getSearchKey,
  updateCurrentCustomerLocation,
  updateSearchKey,
  useAppSelector,
} from '@zonofi/zono-money-store';
import { useCurrentLocation } from '../../../../hooks';
import { MapComponent } from '../../../../map';
import { SVGS } from '../../../../assets';
import { CommonButton } from '../../../../components';
import { isEmpty } from 'lodash';

interface CustomerLocationModalProps {
  open: boolean;
  onClose: () => void;
}
export const CustomerLocationModal: React.FC<CustomerLocationModalProps> = ({
  open,
  onClose,
}) => {
  const searchKey = useAppSelector(getSearchKey);
  const { currentLocation, mapInstance, setMapInstance, reverseGeocode } =
    useCurrentLocation({
      isOnline: true,
    });
  const radius = 100;
  const center = currentLocation
    ? {
        lat: Number(currentLocation.lat),
        lng: Number(currentLocation.lng),
      }
    : undefined;

  return (
    <SwipeableDrawer
      anchor="bottom"
      open={open}
      onClose={onClose}
      onOpen={() => {}}
      disableSwipeToOpen
      PaperProps={{ className: 'customer-location__drawer' }}
    >
      <Box className="customer-location__container">
        <div className="customer-location__header">
          <TouchableOpacity onPress={onClose}>
            <span className={`customer-location__header-text font-semibold`}>
              {'Close'}
            </span>
          </TouchableOpacity>

          <span className="customer-location__header-title font-semibold">
            {'Add Location'}
          </span>
        </div>

        <div className="customer-location__search">
          <SearchIcon />
          <div className="customer-location__search-divider" />
          <input
            type="text"
            placeholder={'Search Location'}
            className="customer-location__search-input"
            onChange={(e) => dispatch(updateSearchKey(e.target.value))}
            value={searchKey}
          />
        </div>

        <div className="map_container">
          <MapComponent
            isAvailable={!!center?.lat && !!center?.lng}
            center={center as { lat: number; lng: number }}
            radius={radius}
            onLoad={(map) => setMapInstance(map)}
            onUnmount={() => setMapInstance(null)}
            onDragEnd={() => {
              const center = mapInstance?.getCenter();
              if (!center) return;
              reverseGeocode(center.lat(), center.lng());
            }}
          />
        </div>

        <div className="location-bottom__container">
          <div className="location-bottom__info">
            <img src={SVGS.GpsLocation} width={20} height={20} />
            <div className="location-bottom__info_heading font-semibold">
              Your Location
            </div>
          </div>
          {currentLocation ? (
            <div className="location-bottom__info_description font-regular">
              <div>{currentLocation.formatted_address}</div>
              <div>{`Lat & Lng: ${currentLocation.lat} & ${currentLocation.lng}`}</div>
            </div>
          ) : (
            <Skeleton
              width="90%"
              height={80}
              sx={{
                marginLeft: '30px',
                marginBottom: '12px',
                marginTop: '-10px',
              }}
            />
          )}

          <CommonButton
            text="Use Current Location"
            onPress={() => {
              dispatch(
                updateCurrentCustomerLocation(
                  currentLocation as FormattedLocation
                )
              );
              onClose?.();
            }}
            spinnerColor="white"
            buttonStyle="button-view"
            disabled={isEmpty(currentLocation)}
          />
        </div>
      </Box>
    </SwipeableDrawer>
  );
};
